.ac{flex-shrink:0;}